import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";


import Dashboard from "views/admin/Dashboard.js";
import Settings from "views/admin/Settings.js";
import Tables from "views/admin/Tables.js";
import Technology from "views/admin/Technology";
import Resource from "../views/admin/Resource";
import ProjectManagement from "../views/admin/ProjectManagement";
import Metting from "../views/meeting/meeting";
import ActionTracking from "../views/actionTracking/List";
import Minutes from "../views/meeting/minutes";
import MeetingDetails from "../views/meeting/meeting/MeetingDetails";
// import CreateMeeting from "components/Meetings/CreateMeeting/Create";
import Create from "../views/meeting/meeting/Create";
import CreateMinutes from "../views/meeting/minutes/CreateMinutes";
import Permission from "views/admin/Permission";
import ResourceProfile from "../views/admin/ResourceProfile";
import ProjectDetails from "views/admin/ProjectDetails";
import MinutesDetails from "../views/meeting/minutes/MinutesDetails";
import PermissionDetails from "../views/admin/PermissionDetails";
import RequestApproval from "../views/admin/RequestApproval";
import LeaveDashboard from "../views/admin/LeaveDashboard";
import TaskPage from "../views/admin/TaskPage";
import FinanceDashboard from "../views/admin/FinanceDashboard";
import Document from "../views/admin/Document";
import Edit from "views/meeting/meeting/Edit";
import FinanceDeliverables from "../views/admin/FinanceDeliverables";
import ConfirmAvailability from "../views/meeting/meeting/confirmAvailability";
import DeveloperTimeline from "../views/admin/DeveloperTimeline";
import RecruitManagement from "../views/admin/RecruitManagement";
import DocumentView from "../views/admin/DocumentView";
import FinanceProjects from "../views/admin/FinanceProjects";
import Logs from "../views/admin/Logs";
import LoggedUserProjects from "../views/admin/LoggedUserProjects";
import Position from "../views/admin/Position";
import Recruitment from "../views/admin/Recruitment";
import RecruitmentSettings from "../views/admin/RecruitmentSettings";
import CreateAction from "../views/actionTracking/Create";
import ActionDetails from "views/actionTracking/ActionDetails";
import AnnualLeave from "views/admin/AnnualLeave";
import StaffPositions from "views/admin/StaffPositions";
import ExamQuestions from "../views/admin/ExamQuestion";
import TaskManagement from "../views/admin/TaskManagement";
import TaskInitiations from "../views/admin/TaskInitiations";
import WorklogGeneralReport from "../views/admin/WorklogGeneralReport";
import ProductManagement from "../views/admin/ProductManagement";
import EventManagement from "../views/admin/EventManagement";
import VmsManagement from "../views/admin/VmsManagement";
import VmsClientManagement from "../views/admin/VmsClientManagement";
import ProductDocumentManagement from "../views/admin/ProductDocumentManagement";
import AssignedTaskManagement from "../views/admin/AssignedTaskManagement";
import SystemRole from "../views/admin/SystemRole";
import LeaveSettings from "../views/admin/LeaveSettings";
import FinanceExpenditure from "views/admin/FinanceExpenditure";
import ProjectReportDetails from "views/admin/ProjectReportDetails";
import ProgramManagement from "../views/admin/ProgramManagement";
import CichiinProjectManagement from "../views/admin/CichiinProjectManagement";
import Funders from "../views/admin/Funders";
import Partners from "views/admin/Partners";
import TasksReportPage from "../views/admin/TaskReportPage";
import ProjectsReportPage from "../views/admin/ProjectsReportPage";
import ProjectGeneralReport from "../views/admin/ProjectGeneralReport";
import ViewSubmittedReports from "../views/admin/ViewSubmittedReports";
import ViewSubmittedProjectReports from "../views/admin/ViewSubmittedProjectReports";

import EmployeesManagement from "../views/admin/EmployeesManagement";
import FunderProjects from "views/admin/FunderProjects";
import PartnerProjects from "views/admin/PartnerProjects";
import PartnerAssignedProjects from "components/Project/PartnerAssignedProjects";
import PartnerProjectDetails from "components/Project/PartnerProjectDetails";
import TasksManagement from "../views/admin/TasksManagement";
import LeaveManagement from "../views/admin/LeaveManagement";
import VehicleManagement from "../views/admin/vehicleManagement";

import GeneralReportPage from "../views/admin/GeneralReportPage";
import SystemPermission from "../views/admin/SystemPermissions";
import ProjectReport from "../views/admin/ProjectReport";
import ViewSubmittedProgramReports from "../views/admin/ViewSubmittedProgramReports";
import UserPermission from "views/admin/Permission/UserPermission";
import StructureList from "views/admin/Structure/StructureList";
import ViewSubmittedTaskReport from "../views/admin/ViewSubmittedTaskReport";
import ProgramAssigned from "../views/admin/ProgramAssigned";
import SystemUsers from "views/admin/Structure/SystemUsers";
import ProjectAssigned from "../views/admin/ProjectAssigned";

const MainPage = () => {
  return (
    <Switch>
      <Route path="/admin/dashboard" exact component={Dashboard} />
      <Route path="/admin/document" exact component={Document} />
      <Route path="/admin/document-view" exact component={DocumentView} />
      <Route
        path="/admin/finance/dashboard"
        exact
        component={FinanceDashboard}
      />
      <Route
        path="/admin/finance/deliverables"
        exact
        component={FinanceDeliverables}
      />
      <Route path="/admin/finance/projects" exact component={FinanceProjects} />
      <Route path="/admin/task/:id" exact component={TaskPage} />
      <Route path="/admin/approval" exact component={RequestApproval} />
      <Route path="/admin/LeaveDashboard" component={LeaveDashboard} />

      <Route path="/admin/technology" exact component={Technology} />
      <Route path="/admin/position" exact component={Position} />
      <Route path="/admin/if-structure" exact component={EmployeesManagement} />
      <Route path="/admin/recruits" exact component={RecruitManagement} />
      <Route path="/admin/permissions" exact component={Permission} />
      <Route path="/admin/timeline" exact component={DeveloperTimeline} />
      <Route path="/admin/projects/:id" exact component={ProjectManagement} />
      <Route path="/admin/programs" exact component={ProgramManagement} />
      <Route path="/admin/projects" exact component={CichiinProjectManagement} />
      <Route path="/admin/funders" exact component={Funders} />
      <Route
        path="/admin/funder-projects/:id"
        exact
        component={FunderProjects}
      />
      <Route
        path="/admin/partner-projects/:id"
        exact
        component={PartnerProjects}
      />
      <Route
        path="/admin/assigned-projects/"
        exact
        component={PartnerAssignedProjects}
      />
      <Route
        path="/admin/assigned-projects/details/:id"
        exact
        component={PartnerProjectDetails}
      />
      <Route path="/admin/programs-assigned"  component={ProgramAssigned} />
      <Route path="/admin/projects-assigned"  component={ProjectAssigned} />
      <Route path="/admin/partners" exact component={Partners} />
      <Route path="/admin/tasks" exact component={TaskManagement} />
      <Route path="/admin/team_tasks" exact component={TaskInitiations} />
      <Route
        path="/admin/my_assignments"
        exact
        component={AssignedTaskManagement}
      />
      <Route path="/admin/product" exact component={ProductManagement} />
      <Route
        path="/admin/product/ems/table/:id"
        exact
        component={EventManagement}
      />
      <Route
        path="/admin/product/vms/table/:id"
        exact
        component={VmsManagement}
      />
      <Route
        path="/admin/product/documents/:id/:name"
        exact
        component={ProductDocumentManagement}
      />
      <Route
        path="/admin/vms/clients/:id"
        exact
        component={VmsClientManagement}
      />
      <Route
        path="/admin/worklog/report"
        exact
        component={WorklogGeneralReport}
      />
      <Route path="/admin/my/projects" exact component={LoggedUserProjects} />
      <Route path="/admin/settings" exact component={Settings} />
      <Route path="/admin/profile/:id" exact component={ResourceProfile} />
      <Route
        path="/admin/project/details/:id"
        exact
        component={ProjectDetails}
      />
      <Route
        path="/admin/permission/details/:id"
        exact
        component={PermissionDetails}
      />
      <Route path="/admin/tables" exact component={Tables} />
      {/* meeting */}
      <Route path="/admin/meeting" exact component={Metting} />
      <Route path="/admin/logs" exact component={Logs} />
      <Route
        path="/admin/meeting/details/:meetingId"
        exact
        component={MeetingDetails}
      />
      <Route path="/admin/edit/meeting/:meetingId" exact component={Edit} />
      <Route path="/admin/schedule-meeting" exact component={Create} />
      <Route path="/admin/create-minutes" exact component={CreateMinutes} />
      <Route
        path="/admin/confirm-availability"
        exact
        component={ConfirmAvailability}
      />
      <Route path="/admin/minutes" exact component={Minutes} />
      <Route path="/admin/recruitment" exact component={Recruitment} />
      <Route
        path="/admin/recruitment_settings"
        exact
        component={RecruitmentSettings}
      />
      <Route path="/admin/exams/:positionId" exact component={ExamQuestions} />
      <Route
        path="/admin/minutes/details/:minutesId"
        exact
        component={MinutesDetails}
      />
      <Route path="/admin/action" exact component={ActionTracking} />
      <Route path="/admin/action/:new" exact component={CreateAction} />
      <Route path="/admin/action/details/:id" exact component={ActionDetails} />
      <Route path="/admin/annual-leave" exact component={AnnualLeave} />
      <Route path="/admin/positions" exact component={StaffPositions} />
      <Route path="/admin/system-permission" exact component={SystemRole} />
      <Route path="/admin/leave/settings" exact component={LeaveSettings} />
      <Route
        path="/admin/finance/expenditure"
        exact
        component={FinanceExpenditure}
      />
      <Route
        path="/admin/finance/expenditure"
        exact
        component={FinanceExpenditure}
      />
      <Route
        path="/admin/report-details"
        exact
        component={ProjectReportDetails}
      />
      <Route path="/admin/tasks/report" exact component={TasksReportPage} />

      <Route
        path="/admin/report/projects"
        exact
        component={ProjectsReportPage}
      />

      <Route path="/admin/view-report" exact component={ProjectGeneralReport} />

      <Route
        path="/admin/reports/view_submitted-reports"
        exact
        component={ViewSubmittedReports}
      />

      <Route
        path="/admin/reports/view_submitted-project_reports"
        exact
        component={ViewSubmittedProjectReports}
      />

      <Route
        path="/admin/reports/view-project-reports"
        exact
        component={ProjectReport}
      />

      <Route
        path="/admin/reports/view-program-reports"
        exact
        component={ViewSubmittedProgramReports}
      />

      <Route
        path="/admin/reports/view-task-reports"
        exact
        component={ViewSubmittedTaskReport}
      />

      <Route path="/admin/tasks-management" exact component={TasksManagement} />

      <Route
        path="/admin/reports-page/report"
        exact
        component={GeneralReportPage}
      />

      <Route path="/admin/resources" exact component={Resource} />

      <Route path="/admin/leave-management" exact component={LeaveManagement} />
      <Route
        path="/admin/seetings"
        // path="/admin/system_permissions"
        exact
        component={SystemPermission}
      />

      <Route
        path="/admin/vehicle-management"
        exact
        component={VehicleManagement}
      />

      <Route path="/admin/permission" exact component={UserPermission} />
      <Route path="/admin/system/settings" exact component={StructureList} />
      <Route path="/admin/system/users" exact component={SystemUsers} />
      <Redirect from="/admin" to="/admin/dashboard" />
    </Switch>
  );
};

export default MainPage;
